module.exports = __webpack_public_path__ + "static/media/status-active.c2fbc0cb.svg";